// $adjst 上报埋点
// import store from '@/store/index'
// import router from '@/router'
// import getUserFingerprint from '@/utils/user-finger-print.js'
// export function adjust_report(token, params) {
//   try {
//     let { prePage: prePath, preRouterName: prePageName } = router.prePageInfo
//     let callbackParams = []
//     if (params) {
//       for (const key in params) {
//         if (params.hasOwnProperty(key)) {
//           callbackParams.push(
//             {key: key + '',
//             value: params[key] + ''
//           })
//         }
//       }
//     }
//     const uuid = store.state.app.userInfo ? store.state.app.userInfo.uuid : '0'
//     const device_id = getUserFingerprint()
//     callbackParams = callbackParams.concat([
//       {key:'window_width', value: window.innerWidth + ''},
//       {key:'uuid', value: uuid},
//       {key:'device_id', value: device_id},
//       {key:'platform', value: 'web'},
//       {key:'pre_path', value: prePath},
//       {key:'pre_page', value: prePageName},
//     ])
//     window.Adjust.trackEvent({
//       eventToken: adjust_map[token],
//       callbackParams: callbackParams
//     })
//   } catch (err) {
//     console.log(err)
//   }
// }

// const adjust_map = {
//   web_to_player_detail: 'vvo3s3',
//   web_blac_catch: 'tnrt4g',
//   web_launch: 'lxy3ym',
//   web_order_paid: '41f803',
//   web_check_skill: 'gty6z6',
//   web_player_skill_list_request: 'cxidvc',
//   web_p_gamechoice_page: 'en5idr',
//   web_e_bchoice_return: 'bmi5ve',
//   web_e_readyornot_return: 'qdtvkj',
//   web_e_gamechoice_button: 'ks3grt',
//   web_e_bchoice_button: '5fyi0j',
//   web_e_readyornot_button: '5c0lrx',
//   web_p_bchoice_page: 'ap2lvs',
//   web_p_readyornot_page: 'drvvi3',
//   // 'home_visit': 'whnpph',
//   'login_page_btn_click': 'k5zehn',
//   'signup_success': 'j8m7ty',
//   'web_raffle_view': 'sjcpyk',
//   'web_raffle_click': '5zjgr8',
//   inapp_purchase: 'cpuzuc',
//   login_success: 'ihd5dq',
//   clogin_success: '2ji0p3',
//   blogin_success: '53lzj9',
//   web_activate_success: '827v3w',
//   page_show: 'vsbue1', // 頁面展現
//   invitelink_click: '8fcs4l', // 簽約用戶邀請連接打開
//   invite_signin: 'fpk08s', // 簽約用戶拉新成功
//   game_select_zero: 'kyqkc6',
//   game_select: 'oq1yt7',
//   skill_visited: 'khddqr'
// }
const adjust_report = () => {};
export { adjust_report };
export default adjust_report;
